import React, { useEffect, useState, useContext } from 'react'
import LineChart from './LineChart'
import DoughnutChart from './DoughnutChart'
import ScheduledPickupContext from '@/product/context/scheduledPickup/scheduledPickupContext'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { useFormik } from 'formik'
import moment from 'moment'
import Loaders from '@/product/components/molecules/Loaders'
import { v4 as uuidv4 } from 'uuid'
import BarChart from './BarChart'
import CustomTable from '@/product/components/molecules/CustomTable'
const Dashboard = (props) => {
    const [dashboardData, setDashboardData] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [totalRecords, setTotalRecords] = useState([])
    const scheduledPickupContext = useContext(ScheduledPickupContext)
    const { getScheduledPickupDashboardData, scheduled_pickup_dashboard } =
        scheduledPickupContext

    const formik = useFormik({
        initialValues: {
            limit: 20,
            page: 1,
            orderby: '',
            slot: '',
            order: '',
        },
        enableReinitialize: false,
        onSubmit: (values) => {
            const currentDate = moment()
            if (values.slot == 'today') {
                values.year = false
                values.month = false
                values.week = false
                values.sameday = true
                const startTime = `${currentDate.format('MM-DD-YYYY')} 00:00 am`
                const endTime = `${currentDate.format('MM-DD-YYYY')} 23:59 pm`
                values.start_date = moment(
                    startTime,
                    'MM-DD-YYYY h:mm a'
                ).format()
                values.end_date = moment(endTime, 'MM-DD-YYYY h:mm a').format()
            } else if (values.slot == 'week') {
                values.year = false
                values.month = false
                values.week = true
                values.sameday = false
            } else if (values.slot == 'month') {
                values.year = false
                values.week = false
                values.month = currentDate.format('MM')
                values.sameday = false
            } else if (values.slot == 'year') {
                values.year = currentDate.format('YYYY')
                values.month = false
                values.week = false
                values.sameday = false
            } else {
                values.year = false
                values.month = false
                values.week = false
                values.sameday = false
            }
            console.log(values, 'bnnnnn')
            getScheduledPickupDashboardData(values, 'main')
        },
    })
    useEffect(() => {
        formik.handleSubmit()
    }, [formik.values])

    const searchInfo = [
        {
            label: 'Select',
            placeholder: 'All Time',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'select',
            name: 'slot',
            formik: formik,
            native: true,
            options: [
                {
                    show: 'Today',
                    value: 'today',
                },
                {
                    show: 'This Week',
                    value: 'week',
                },
                {
                    show: 'This Month',
                    value: 'month',
                },
                {
                    show: 'This Year',
                    value: 'year',
                },
            ],
        },
    ]

    const tableValues = [
        {
            field: 'bookingCount',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'NEW ORDERS',
        },
        {
            field: 'servingCount',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'SERVED',
        },
        {
            field: 'noshowCount',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'NO-SHOWS',
        },
        {
            field: 'removedCount',
            clickID: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'CANCELLED',
        },
        {
            field: 'booking_start_date',
            type: 'datetime',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'AVG WAIT TIME',
        },
        {
            field: 'timeWaited',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'AVG SERVE TIME',
        },
    ]

    useEffect(() => {
        if (scheduled_pickup_dashboard) {
            console.log(scheduled_pickup_dashboard.records, 'allghhhk')
            if (
                scheduled_pickup_dashboard.records &&
                scheduled_pickup_dashboard.records.length
            ) {
                console.log(scheduled_pickup_dashboard.records, 'allghhhk')
                let changeData = scheduled_pickup_dashboard.records
                changeData.map((value, index) => {
                    value.id = uuidv4()
                })

                setDashboardData(changeData)
                setIsLoading(false)
                setTotalRecords([
                    {
                        title: 'Total visits',
                        val: '9',
                        icon: 'trending_up',
                        scaleVal: '+ 100%',
                        trendCol: 'blue',
                    },
                    {
                        title: 'New orders',
                        val: '167',
                        icon: 'trending_down',
                        scaleVal: '+ 10%',
                        trendCol: 'red',
                    },
                    {
                        title: 'Served',
                        val: scheduled_pickup_dashboard.records[0].servingCount,
                        icon: 'trending_down',
                        scaleVal: '+ 10%',
                        trendCol: 'red',
                    },
                    {
                        title: 'Serve rate',
                        val: '56',
                        icon: 'trending_down',
                        scaleVal: '+ 20%',
                        trendCol: 'green',
                    },
                    {
                        title: 'Avg serve duration',
                        val: '85',
                        icon: 'trending_up',
                        scaleVal: '+ 20%',
                        trendCol: 'blue',
                    },
                    {
                        title: 'No-shows',
                        val: scheduled_pickup_dashboard.records[0].noshowCount,
                        icon: 'trending_down',
                        scaleVal: '+ 10%',
                        trendCol: 'red',
                    },
                    {
                        title: 'No-show rate',
                        val: scheduled_pickup_dashboard.records[0].noshowCount,
                        icon: 'trending_down',
                        scaleVal: '+ 10%',
                        trendCol: 'red',
                    },
                    {
                        title: 'Cancellations',
                        val: scheduled_pickup_dashboard.records[0].removedCount,
                        icon: 'trending_down',
                        scaleVal: '+ 10%',
                        trendCol: 'red',
                    },
                    {
                        title: 'Removed',
                        val: scheduled_pickup_dashboard.records[0].removedCount,
                        icon: 'trending_down',
                        scaleVal: '+ 10%',
                        trendCol: 'red',
                    },
                    {
                        title: 'Avg Wait Time',
                        val: scheduled_pickup_dashboard.records[0].waitingCount,
                        icon: 'trending_up',
                        scaleVal: '+ 20%',
                        trendCol: 'orange',
                    },
                ])
            } else {
                setDashboardData([])
            }
        }
    }, [scheduled_pickup_dashboard])

    return (
        <div className="sheduleDashboardContainer">
            <div className="dvCardRootElement mt-4">
                <CustomSearch searchInfo={searchInfo} formik={formik} />
                <div className="dvCardHdrRoot">
                    <div className="dvCardTit">
                        <h3 className="tit">Picker Activity</h3>
                        <h4 className="tagTit">Employee summary</h4>
                    </div>
                    <div className="dvRgtelemet"></div>
                </div>
                <div className="dvActvtRootCntnr">
                    <div className="dvTckrCard">
                        <h4 className="tit">Time Tracked</h4>
                        <div className="dvDonutChat">
                            <DoughnutChart data={dashboardData} />
                        </div>
                    </div>
                    <div className="dvPrtvtCard">
                        <h4 className="tit">Picker Productivity</h4>
                        <div
                            className="dvDonutChat"
                            style={{ height: '250px' }}
                        >
                            <LineChart />
                        </div>
                    </div>
                </div>
            </div>
            <div className="dvCardRootElement">
                <div className="dvCardHdrRoot">
                    <div className="dvCardTit">
                        <h3 className="tit">Summary</h3>
                        <h4 className="tagTit">Activity summary</h4>
                    </div>
                    <div className="dvRgtelemet">
                        <svg
                            className="mr-1"
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M10.8021 11.1562C10.5117 11.1562 10.2708 11.397 10.2708 11.6874V12.7499C10.2708 13.2387 9.87417 13.6353 9.38542 13.6353H4.07292C3.58417 13.6353 3.1875 13.2387 3.1875 12.7499V4.24992C3.1875 3.76117 3.58417 3.3645 4.07292 3.3645H6.375V6.72908C6.375 7.0195 6.61583 7.26033 6.90625 7.26033H10.2708V8.14575C10.2708 8.43617 10.5117 8.677 10.8021 8.677C11.0925 8.677 11.3333 8.43617 11.3333 8.14575V6.72908C11.3333 6.58742 11.2767 6.45284 11.1775 6.35367L7.28167 2.45784C7.18213 2.35818 7.0471 2.30213 6.90625 2.302H4.07292C2.99625 2.302 2.125 3.17325 2.125 4.24992V12.7499C2.125 13.8266 2.99625 14.6978 4.07292 14.6978H9.38542C10.4621 14.6978 11.3333 13.8266 11.3333 12.7499V11.6874C11.3333 11.397 11.0925 11.1562 10.8021 11.1562ZM7.4375 4.11534L9.52 6.19784H7.4375V4.11534ZM14.8325 10.122C14.8042 10.1858 14.7688 10.2424 14.7192 10.292L12.5942 12.417C12.4879 12.5233 12.3533 12.5728 12.2188 12.5728C12.0842 12.5728 11.9496 12.5233 11.8433 12.417C11.7445 12.317 11.6891 12.1821 11.6891 12.0416C11.6891 11.901 11.7445 11.7661 11.8433 11.6662L13.0617 10.4478H6.90625C6.61583 10.4478 6.375 10.207 6.375 9.91658C6.375 9.62617 6.61583 9.38533 6.90625 9.38533H13.0617L11.8433 8.167C11.6379 7.96159 11.6379 7.62159 11.8433 7.41617C12.0487 7.21075 12.3888 7.21075 12.5942 7.41617L14.7192 9.54117C14.7688 9.59075 14.8042 9.64742 14.8325 9.71117C14.8892 9.83867 14.8892 9.98742 14.8325 10.1149V10.122Z"
                                fill="#537E20"
                            />
                        </svg>
                        Export
                    </div>
                </div>
                <div className="dvActvtRootCntnr fullCols">
                    <div className="dvTckrCard p-0 border-0">
                        <div className="StatistickCardGrid">
                            {totalRecords.map((data, index) => (
                                <div className="StatistickCard" key={index}>
                                    <h4 className="AnalticsTit">
                                        {data.title}
                                    </h4>
                                    <strong className="AnalticsVal">
                                        {data.val}
                                    </strong>
                                    <span
                                        className={`AnalticsScale ${data.trendCol}`}
                                    >
                                        <span className="material-icons-outlined">
                                            {data.icon}
                                        </span>
                                        {data.scaleVal}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="dvCardRootElement">
                <div className="dvCardHdrRoot">
                    <div className="dvCardTit">
                        <h3 className="tit">Weekdays</h3>
                    </div>
                    <div className="dvRgtelemet"></div>
                </div>
                <div className="dvActvtRootCntnr fullCols">
                    <div className="dvTckrCard">
                        <h4 className="tit">Time Tracked</h4>
                        <div className="dvDonutChat">
                            <BarChart />
                        </div>
                    </div>
                </div>
            </div>
            <div className="dvSiteStarg">
                <div className="dvCardRootElement">
                    <div className="dvCardHdrRoot">
                        <div className="dvCardTit">
                            <h3 className="tit">By time of day</h3>
                        </div>
                        <div className="dvRgtelemet"></div>
                    </div>
                    <div className="dvProgressView">
                        <div className="mb-3 prVJumbo">
                            <div className="induProData">
                                <p>New orders</p>
                                <span>
                                    {dashboardData[0]?.bookingCount || 0}
                                </span>
                            </div>
                            <progress
                                id="file"
                                value={dashboardData[0]?.bookingCount || 0}
                                max="100"
                            >
                                {dashboardData[0]?.bookingCount || 0}
                            </progress>
                        </div>
                        <div className="mb-3 prVJumbo">
                            <div className="induProData">
                                <p>Served</p>
                                <span>
                                    {dashboardData[0]?.servingCount || 0}
                                </span>
                            </div>
                            <progress
                                id="file"
                                value={dashboardData[0]?.servingCount || 0}
                                max="100"
                            >
                                {dashboardData[0]?.servingCount || 0}
                            </progress>
                        </div>
                        <div className="mb-3 prVJumbo">
                            <div className="induProData">
                                <p>Cancelled</p>
                                <span>
                                    {dashboardData[0]?.removedCount || 0}
                                </span>
                            </div>
                            <progress
                                id="file"
                                value={dashboardData[0]?.removedCount || 0}
                                max="100"
                            >
                                {dashboardData[0]?.removedCount || 0}
                            </progress>
                        </div>
                        <div className="mb-3 prVJumbo">
                            <div className="induProData">
                                <p>No-shows</p>
                                <span>
                                    {dashboardData[0]?.noshowCount || 0}
                                </span>
                            </div>
                            <progress
                                id="file"
                                value={dashboardData[0]?.noshowCount || 0}
                                max="100"
                            >
                                {dashboardData[0]?.noshowCount || 0}
                            </progress>
                        </div>
                    </div>
                </div>
                <div className="dvCardRootElement">
                    <div className="dvCardHdrRoot">
                        <div className="dvCardTit">
                            <h3 className="tit">Trends</h3>
                        </div>
                        <div className="dvRgtelemet">
                            <span className="material-icons">launch</span>
                        </div>
                    </div>
                    <div className="dvDonutChat" style={{ height: '200px' }}>
                        <DoughnutChart
                            isTrends={true}
                            dashboardData={dashboardData}
                        />
                    </div>
                </div>
                <div className="dvCardRootElement">
                    <div className="dvCardHdrRoot">
                        <div className="dvCardTit">
                            <h3 className="tit">Visitors</h3>
                        </div>
                        <div className="dvRgtelemet"></div>
                    </div>
                    <div className="dvVisitorContain">
                        <div className="dvVisitorCard mb-3">
                            <div className="dvLftEle">
                                <p className="tit">Total contacts</p>
                                <span className="val">3</span>
                            </div>
                            <div className="dvRttEle">
                                <LineChart isVisitor={true} />
                            </div>
                        </div>
                        <div className="dvVisitorCard mb-3">
                            <div className="dvLftEle">
                                <p className="tit">Repeat customer</p>
                                <span className="val">30</span>
                            </div>
                            <div className="dvRttEle">
                                <LineChart isVisitor={true} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="dvCardRootElement">
                <div className="dvCardHdrRoot">
                    <div className="dvCardTit">
                        <h3 className="tit">User</h3>
                    </div>
                    <div className="dvRgtelemet"></div>
                </div>
                <div className="dvActvtRootCntnr fullCols">
                    <div className="dvTckrCard p-0 border-0">
                        <CustomTable
                            formik={formik.values}
                            tableBody={dashboardData}
                            tableValues={tableValues}
                            tableActions={[]}
                            allData={scheduled_pickup_dashboard}
                            isLoading={isLoading}
                            loadingTemplate={'table'}
                            changeTableFunction={
                                getScheduledPickupDashboardData
                            }
                            hideCompactView={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard
